<div class="dashboard-transport-registration-smartphone-connection">

    <div class="vertical-layout">
        <div class="form" [formGroup]="detailsFormGroup">
            <mat-radio-group class="messagingoptions" formControlName="driverCommunicationOption" aria-label="Choose driver communication option">
              <ng-container *ngFor="let option of communicationOptions">
                <div *ngIf="option === 'loaner'">
                    <mat-radio-button class="radio-btn" value={{terminalContextConstants.DRIVER_COMMUNICATION_LOANER}}>
                        {{'Leihgerät wird beim Pförtner geholt' | translate:
                            ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.loaner',
                            translationService.language]}}
                    </mat-radio-button>
                    <div class="option-hint">
                      {{'Sie erhalten ein Gerät an der Pforte und nutzen GlobalConnect für....' | translate:
                        ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.loaner.hint',
                        translationService.language]}}
                    </div>
                </div>
                <div *ngIf="option === 'phone-call'">
                    <mat-radio-button class="radio-btn" value="phone-call">
                        {{'Ich möchte angerufen werden' | translate:
                              ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.phone-call',
                              translationService.language]}}
                    </mat-radio-button>
                    <div class="option-hint">{{'Wir rufen Sie auf Ihrem Telefon an.' | translate:
                      ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.phone-call.hint',
                      translationService.language]}}
                    </div>
                </div>
                <div *ngIf="option === 'sms'">
                    <mat-radio-button class="radio-btn" value="sms">
                        {{'Ich möchte SMS Nachrichten erhalten' | translate:
                              ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.sms',
                              translationService.language]}}
                    </mat-radio-button>
                    <div class="option-hint">{{'Wir senden Ihnen SMS auf Ihr Telefon.' | translate:
                      ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.sms.hint',
                      translationService.language]}}
                    </div>
                </div>
                <div *ngIf="option === 'global-connect'">
                    <mat-radio-button class="radio-btn" value={{terminalContextConstants.DRIVER_COMMUNICATION_OWN_SMARTPHONE}}>
                      {{'Ich will das eigene Smartphone mit GlobalConnect verwenden' | translate:
                            ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.own-smartphone',
                            translationService.language]}}
                    </mat-radio-button>
                    <div class="option-hint">
                      {{'Alle Nachrichten erhalten Sie auf die installierte GC APP' | translate:
                          ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.own-smartphone.hint',
                          translationService.language]}}
                    </div>
                </div>
                <div *ngIf="option === 'messaging-hint'">
                  <div>{{'Weiterführender Hinweis zu den Messaging Optionen' | translate:
                    ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.messaging-hint',
                    translationService.language]}}</div>
                </div>
              </ng-container>
            </mat-radio-group>
            <div>{{'Description for messaging options' | translate:
                ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.description',
                translationService.language]}}</div>
        </div>
        <div class="vertical-spacer"></div>
        <ng-container *ngIf="showGcAppInfo">
            <div class="title">{{'Global Connect App' | translate:
                ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.global-connect-app.headline',
                translationService.language]}}</div>
            <div class="spacer"></div>
            <qrcode *ngIf="qrCodeUrl" [qrdata]="qrCodeUrl" [scale]="6"></qrcode>
            <div class="app-store-headline">
                <h3>
                {{'Global Connect App' | translate:
                ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.global-connect-app.app-store-headline',
                translationService.language]}}
                </h3>
            </div>
            <div class="app-store-hint">
                {{'Global Connect App' | translate:
                ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.global-connect-app.app-store-hint',
                translationService.language]}}
            </div>
            <div class="grid">
                <div class="app-store-button">
                    <img (click)="openAppOverlay('apple-app-store', appleAppStoreUrl, 'svg')"
                        src="/assets/default/icons/app-store/apple-app-store-badge-{{translationService.language}}.svg"
                        class="app-badge-apple apple-app-store-badge" alt="" />
                </div>
                <div class="spacer"></div>
                <div class="google-play-button">
                    <img (click)="openAppOverlay('google-play-store', googlePlayStoreUrl, 'png')"
                        src="/assets/default/icons/app-store/google-play-store-badge-{{translationService.language}}.png"
                        class="app-badge-google google-play-store-badge" alt="" />
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="phoneNumberRequired && !hidePhoneNumberInput">
            <form [formGroup]="phoneNumberFormGroup">
                <sc-phone-number-field *ngIf="!showPhoneNumberDialog" formControlName="phoneNumber" class="phone-number" [required]="true" [showOthersOption]="true" [limitCountries]="phonenumberAllowedCountries" [label]="'Phone Number' | translate:
                ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.phone-number.label',
                translationService.language]"></sc-phone-number-field>
                <sc-phone-number-dialog-field *ngIf="showPhoneNumberDialog" formControlName="phoneNumber" class="phone-number" [required]="true" [showOthersOption]="true" [limitCountries]="phonenumberAllowedCountries" [label]="'Phone Number' | translate:
                ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.option.phone-number.label',
                translationService.language]"></sc-phone-number-dialog-field>
            </form>
            
            <div class="info">{{'Used phonenumber' | translate:
                ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.used-phone-number',
                translationService.language]}} {{phoneNumberFormGroup.value.phoneNumber}}</div>
            
            <div *ngIf="!phoneNumberValid" class="error">{{'Invalid format' | translate:
                ['tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.invalid-phone-number',
                translationService.language]}}</div>
            <div *ngIf="phoneNumberValid">&nbsp;</div>

            <div *ngIf="showHints" class="title" [innerHTML]="'#undefined' | translate: 
                ['tmc-yard.entity.transport.phone-hint', translationService.language] | trustHtml"></div>
        </ng-container>
        <div class="vertical-spacer"></div>
    </div>

</div>
